import { Icon, IconButton, HStack, Stack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Text } from 'native-base';
import React, { useState } from 'react';

import { TableContentItemText } from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { AddedProductItemList } from '../../../../../utils/types';

interface InvalidProductItemProps {
  data: AddedProductItemList;
}

export const InvalidProductItem: React.FC<InvalidProductItemProps> = ({ data }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const [sectionIsOpened, setSectionIsOpened] = useState(false);
  const toggleSection = () => setSectionIsOpened((state) => !state);

  const productTitleDisplay =
    data?.productNameNormalized || data?.productDisplayNormalized || messageError;

  return (
    <VStack w={'full'} flex={1}>
      <HStack w="full" pb={Spacing['stack.quarck']}>
        <HStack alignItems={'center'} space={Spacing['inline.nano']}>
          <Icon
            name="Warning"
            size="xxs"
            padding={Spacing['inline.quarck']}
            variant="rounded"
            backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
            color={Color['feedback.attention.default']}
          />
          <TableContentItemText
            fontSize={{ base: Typography['fontsize.lg'], sm: Typography['fontsize.md'] }}
            variant={isMobile ? 'bold' : 'regular'}>
            {productTitleDisplay}
          </TableContentItemText>
        </HStack>
        {!isMobile && (
          <IconButton
            icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
            testId="open-product-category"
            onPress={toggleSection}
            iconColor={Color['neutral.black']}
          />
        )}
      </HStack>
      {(sectionIsOpened || isMobile) && (
        <VStack w="full" space={Spacing['stack.nano']}>
          {data?.errors?.map((error) => (
            <Stack
              key={error?.errorId}
              direction={{ base: 'column', lg: 'row' }}
              w="full"
              justifyContent={'space-between'}
              space={{
                base: Spacing['inline.nano'],
                lg: Spacing['inline.xs'],
              }}>
              <Text
                color="black"
                fontSize={Typography['fontsize.md']}
                {...(isDesktop && { flex: 0.2 })}
                {...(!isDesktop && { variant: 'semibold' })}>
                {error?.errorTitle || messageError}
              </Text>
              <Text
                color="neutral.darkest"
                fontSize={Typography['fontsize.md']}
                {...(isDesktop && { flex: 1, textAlign: 'end' })}>
                {error?.errorMessage && error?.errorSuggest
                  ? `${error?.errorMessage} ${error?.errorSuggest}`
                  : messageError}
              </Text>
            </Stack>
          ))}
        </VStack>
      )}
    </VStack>
  );
};
